/**
* DevExpress Analytics (license\_license.tools.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { version } from '../analytics-version';
import TrialPanel from 'devextreme/core/trial_panel';
const { showTrialPanel, registerTrialPanelComponents } = TrialPanel;
registerTrialPanelComponents();
export function _addLicenseTrigger(licenseOptions) {
    if (licenseOptions && !licenseOptions.isLicensed) {
        showTrialPanel(licenseOptions.link, version);
    }
}
